"use client";
import * as React from "react";
export const tabsContext = /*#__PURE__*/ React.createContext({
    current: "",
    onTabClick: ()=>undefined,
    onLinkKeyDown: ()=>undefined
});
